<template>
	<v-menu
		:offset-y="$vuetify.breakpoint.mdAndUp"
		v-model="show"
		:close-on-content-click="false"
		max-height="100%"
		:max-width="max_width"
		transition="fade-transition"
		style="left: 0px!important">

		<template v-slot:activator="{ on }">
			<v-btn
				flat icon
				v-on="on"
				class="menu-trigger">
				<v-icon large v-if="show">close</v-icon>
				<v-icon large v-else>menu</v-icon>
			</v-btn>
		</template>

		<v-card class="card-menu">
			<div v-shortkey="['esc']" @shortkey="show = false"></div>

			<!-- Compact header bar -->
			<div class="menu-topbar">
				<div class="user-block">
					<div class="user-avatar">
						<v-icon class="user-icon">person</v-icon>
					</div>
					<div class="user-info">
						<span class="user-label">Connecté en tant que</span>
						<span class="user-name">{{ user.name }}</span>
					</div>
				</div>
				<div class="topbar-actions">
					<router-link
						v-for="about_page in about_pages"
						:key="about_page.name"
						:to="about_page.link_to"
						:title="about_page.name"
						:style="{ color: about_page.color }"
						class="topbar-link"
						@click.native="show = false">
						<v-icon :color="about_page.color">{{ about_page.icon }}</v-icon>
					</router-link>
					<router-link
						v-if="is_admin"
						v-for="admin_page in admin_pages"
						:key="admin_page.name"
						:to="admin_page.link_to"
						:title="admin_page.name"
						class="topbar-link topbar-link--admin"
						@click.native="show = false">
						<v-icon :color="admin_page.color">{{ admin_page.icon }}</v-icon>
					</router-link>
					<span class="topbar-divider"></span>
					<button class="topbar-btn topbar-btn--logout" @click="signOut()" title="Déconnexion">
						<v-icon>power_settings_new</v-icon>
					</button>
					<button class="topbar-btn" @click="show = false" title="Fermer le menu">
						<v-icon>close</v-icon>
					</button>
				</div>
			</div>

			<!-- Main navigation -->
			<div class="menu-body">
				<div class="menu-columns">
					<div
						v-for="(menu, i) in menus"
						:key="'menu' + i"
						class="nav-column">
						<div class="nav-header">
							<v-icon class="nav-header-icon">{{ menu.icon }}</v-icon>
							{{ menu.name }}
						</div>
						<router-link
							v-for="(child, j) in menu.children"
							:key="'child' + j"
							:to="child.link_to"
							:title="child.description || child.name"
							class="nav-item"
							@click.native="show = false">
							<span class="nav-item-text">{{ child.name }}</span>
							<span v-if="child.is_new" class="badge-new">new</span>
						</router-link>
					</div>
				</div>
			</div>

		</v-card>
	</v-menu>
</template>

<script>
export default {
	data () {
		return {
			show: false,
			menus: [],
			about_pages: [],
			admin_pages: []
		}
	},
	computed: {
		user () {
			return this.$store.getters.user || {}
		},
		is_admin () {
			return this.$user.isAdmin()
		},
		max_width () {
			return this.$vuetify.breakpoint.smAndDown ? '100%' : '50%'
		}
	},
	watch: {
		show (val) {
			if (!val) return
			let userShortcuts = this.getLocalStorageCustoms()
			if (userShortcuts) {
				let section = {
					name: 'Raccoucis Utilisateur',
					icon: 'person',
					description: '',
					children: userShortcuts
				}
				for (let i = 0; i < this.menus.length; i++) {
					if (this.menus[i].name === section.name) {
						this.menus[i] = section
						return
					}
				}
				this.menus.push(section)
			}
		}
	},
	methods: {
		getLocalStorageCustoms () {
			try {
				let data = window.localStorage.getItem('home_links')
				if (data) {
					data = JSON.parse(data)
					if (Array.isArray(data)) {
						return data
					} else {
						// backward home 1.0 compatibility
						let customLinks = []
						for (const position in data) {
							for (const section in data[position]) {
								for (const routeName in data[position][section]) {
									let route = data[position][section][routeName]
									let linkTo = { path: route.path }
									if (route.params) linkTo.params = route.params
									if (route.query) linkTo.query = route.query
									if (route.props) linkTo.props = route.props
									let childMenu = {
										name: routeName,
										description: route.meta.description,
										link_to: linkTo
									}
									customLinks.push(childMenu)
								}
							}
						}
						return customLinks
					}
				}
			} catch (error) {
				console.log(error)
				return false
			}
		},
		signOut () {
			// Clear local state first
			this.$cookies.remove('user')
			let user = {
				email: null,
				name: null,
				image: null,
				maestroAuth: null
			}
			this.$store.commit('set_user', user)

			// Then trigger OIDC signout redirect (this will redirect to SSO logout)
			this.$store.dispatch('auth/signOut')
				.catch((error) => {
					console.log('OIDC signout error:', error.message)
					// If OIDC signout fails, still redirect to login
					this.$router.push({
						name: 'login',
						query: {
							next_url: this.$route.fullPath
						}
					}).catch((err) => {
						console.log(err.message)
					})
				})

			this.$emit('menu-close')
			this.show = false
		}
	},
	created () {
		this.$router.options.routes.map(route => {
			if (route.meta.admin_btn) {
				let linkTo = { name: route.name }
				if (route.params) linkTo.params = route.params
				if (route.query) linkTo.query = route.query
				if (route.props) linkTo.props = route.props
				this.admin_pages.push({
					name: route.meta.label,
					icon: route.meta.icon,
					description: route.meta.description,
					color: route.meta.admin_btn_color,
					link_to: linkTo
				})
			} else if (route.meta.about_btn) {
				let linkTo = { name: route.name }
				if (route.params) linkTo.params = route.params
				if (route.query) linkTo.query = route.query
				if (route.props) linkTo.props = route.props
				this.about_pages.push({
					name: route.meta.label,
					icon: route.meta.icon,
					description: route.meta.description,
					color: route.meta.about_btn_color,
					link_to: linkTo
				})
			}
			if (route.children) {
				let section = {
					name: route.meta.label,
					icon: route.meta.icon,
					description: route.meta.description,
					children: []
				}
				route.children.map(child => {
					// Skip routes that are disabled, have no label, or are special buttons
					if (!child.meta.disabled && child.meta.label && !child.meta.admin_btn && !child.meta.about_btn) {
						let linkTo = { name: child.name }
						if (child.params) linkTo.params = child.params
						if (child.query) linkTo.query = child.query
						if (child.props) linkTo.props = child.props
						let childMenu = {
							name: child.meta.label,
							icon: child.meta.icon,
							description: child.meta.description,
							is_new: child.meta.is_new,
							link_to: linkTo
						}
						section.children.push(childMenu)
					}
					if (child.meta.admin_btn) {
						let linkTo = { name: child.name }
						if (child.params) linkTo.params = child.params
						if (child.query) linkTo.query = child.query
						if (child.props) linkTo.props = child.props
						this.admin_pages.push({
							name: child.meta.label,
							icon: child.meta.icon,
							description: child.meta.description,
							color: child.meta.admin_btn_color,
							link_to: linkTo
						})
					} else if (child.meta.about_btn) {
						let linkTo = { name: child.name }
						if (child.params) linkTo.params = child.params
						if (child.query) linkTo.query = child.query
						if (child.props) linkTo.props = child.props
						this.about_pages.push({
							name: child.meta.label,
							icon: child.meta.icon,
							description: child.meta.description,
							color: child.meta.about_btn_color,
							link_to: linkTo
						})
					}
				})
				if (section.children.length > 0) {
					this.menus.push(section)
				}
			}
		})
	}
}
</script>

<style lang="stylus" scoped>
// ========================================
// Menu Card
// ========================================
.card-menu.v-card
	background: var(--v-background-darken1)
	border: 1px solid var(--v-background-lighten1)
	border-radius: 3px
	box-shadow: 0 12px 40px rgba(0, 0, 0, 0.4)
	overflow: visible
	max-height: 90vh
	display: flex
	flex-direction: column

// Prevent menu from sliding during close
.v-menu__content
	left: 0 !important

// ========================================
// Top Bar (compact header)
// ========================================
.menu-topbar
	display: flex
	align-items: center
	justify-content: space-between
	padding: 10px 14px
	background: linear-gradient(135deg, var(--v-background-darken1) 0%, var(--v-background-lighten1) 100%)
	border-bottom: 1px solid var(--v-background-lighten1)

.user-block
	display: flex
	align-items: center
	gap: 10px

.user-avatar
	display: flex
	align-items: center
	justify-content: center
	width: 36px
	height: 36px
	background: var(--v-background-lighten1)
	border-radius: 3px
	border: 1px solid var(--v-background-lighten2)

.user-icon
	font-size: 20px
	color: var(--v-background-lighten4)

.user-info
	display: flex
	flex-direction: column
	gap: 1px

.user-label
	font-size: 10px
	text-transform: uppercase
	letter-spacing: 0.5px
	color: var(--v-background-lighten3)

.user-name
	font-size: 14px
	font-weight: 600
	color: #fff

.topbar-actions
	display: flex
	align-items: center
	gap: 4px

.topbar-link
	display: flex
	align-items: center
	justify-content: center
	width: 36px
	height: 36px
	border-radius: 3px
	transition: all 0.15s ease
	&:hover
		background: var(--v-background-lighten1)
		transform: scale(1.1)

.topbar-link--download
	animation: pulse-download 2s ease-in-out infinite
	&:hover
		background: rgba(105, 240, 174, 0.15)

@keyframes pulse-download
	0%, 100%
		opacity: 1
	50%
		opacity: 0.6

.topbar-link--admin
	&:hover
		background: var(--v-background-lighten1)

.topbar-divider
	width: 1px
	height: 20px
	background: var(--v-background-lighten2)
	margin: 0 8px

.topbar-btn
	display: flex
	align-items: center
	justify-content: center
	width: 36px
	height: 36px
	border: none
	border-radius: 3px
	background: transparent
	color: var(--v-background-lighten4)
	cursor: pointer
	transition: all 0.15s ease
	&:hover
		background: var(--v-background-lighten1)
		color: #fff

.topbar-btn--logout:hover
	background: rgba(244, 67, 54, 0.15)
	color: #f44336

.topbar-btn--logout:hover
	background: rgba(244, 67, 54, 0.15)
	color: #f44336

// ========================================
// Menu Body
// ========================================
.menu-body
	padding: 16px
	overflow-y: auto
	flex: 1

.menu-columns
	display: flex
	flex-wrap: wrap
	gap: 24px

// ========================================
// Navigation Columns
// ========================================
.nav-column
	min-width: 160px

.nav-header
	display: flex
	align-items: center
	gap: 8px
	font-size: 13px
	font-weight: 600
	color: #fff
	padding-bottom: 10px
	margin-bottom: 6px
	border-bottom: 2px solid var(--v-primary-base)

.nav-header-icon
	font-size: 18px
	color: var(--v-primary-base)

// ========================================
// Navigation Items
// ========================================
.nav-item
	position: relative
	display: flex
	align-items: center
	padding: 8px 12px
	margin: 0 -12px
	color: var(--v-background-lighten4)
	text-decoration: none
	font-size: 13px
	border-radius: 2px
	overflow: hidden
	transition: all 0.2s ease
	&::before
		content: ''
		position: absolute
		left: 0
		top: 0
		width: 3px
		height: 100%
		background: var(--v-primary-base)
		transform: scaleY(0)
		transition: transform 0.2s ease
	&::after
		content: ''
		position: absolute
		inset: 0
		background: linear-gradient(90deg, var(--v-primary-base) 0%, transparent 100%)
		opacity: 0
		transition: opacity 0.2s ease
		z-index: -1
	&:hover
		color: #fff
		transform: translateX(4px)
		&::before
			transform: scaleY(1)
		&::after
			opacity: 0.15

.nav-item-text
	flex: 1
	position: relative
	z-index: 1

// ========================================
// New Badge
// ========================================
.badge-new
	padding: 2px 5px
	font-size: 9px
	font-weight: 600
	text-transform: uppercase
	background: var(--v-primary-base)
	color: #fff
	border-radius: 2px
	margin-left: 8px

// ========================================
// Menu Trigger
// ========================================
.menu-trigger
	transition: transform 0.2s ease
	&:hover
		transform: scale(1.05)

// ========================================
// Responsive
// ========================================
.menuable__content__active
	left: 0px !important

@media (max-width: 959px)
	.menuable__content__active
		top: 0px !important
		max-height: 100vh !important

	.card-menu.v-card
		max-height: 100vh
		border-radius: 0

	.menu-topbar
		flex-wrap: wrap
		gap: 8px

	.menu-columns
		flex-direction: column
		gap: 16px

	.nav-column
		min-width: 100%

@media (max-width: 600px)
	.user-block
		width: 100%
		margin-bottom: 4px

	.topbar-actions
		width: 100%
		justify-content: flex-end
</style>



// WEBPACK FOOTER //
// src/App_menu.vue